var _script, _script2, _style, _path, _path2, _path3, _path4, _path5, _path6, _script3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWstethLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 18.6 26",
    style: {
      enableBackground: "new 0 0 18.6 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    id: "argent-x-extension",
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb"
  })), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    type: "text/javascript"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st0,.st1,.st2{fill:#00a3ff}.st1,.st2{opacity:.6;enable-background:new}.st2{opacity:.2}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m1.7 11.7-.2.3c-2.3 3.6-1.8 8.3 1.3 11.3C4.5 25.1 6.9 26 9.3 26L1.7 11.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m9.3 16-7.6-4.4L9.3 26V16zM16.9 11.7l.2.3c2.3 3.6 1.8 8.3-1.3 11.3C14 25.1 11.7 26 9.3 26l7.6-14.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m9.3 16 7.6-4.4L9.3 26V16zM9.3 6.3v7.5l6.6-3.7-6.6-3.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m9.3 6.3-6.6 3.8 6.6 3.7V6.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3 0 2.7 10.1l6.6-3.8V0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m9.3 6.3 6.6 3.8L9.3 0v6.3z"
  })), _script3 || (_script3 = /*#__PURE__*/React.createElement("script", {
    id: "bw-fido2-page-script"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWstethLogo);
export default __webpack_public_path__ + "static/media/wsteth-logo.6f6be0d95c6aefb01c6cadfc6b0b18e6.svg";
export { ForwardRef as ReactComponent };